import React from 'react';
import { RuleLayout } from '../../rule-layout';
export const CustomRuleFixer = _ref => {
  var _ruleResult$fixerProp;
  let {
    ruleResult
  } = _ref;
  const {
    customFixer
  } = ruleResult.fixerProps;
  if (! /*#__PURE__*/React.isValidElement(customFixer)) {
    console.error('customFixer is not a valid React element');
    return null;
  }
  return /*#__PURE__*/React.createElement(RuleLayout, {
    description: ruleResult.description,
    design: (_ruleResult$fixerProp = ruleResult.fixerProps.design) == null ? void 0 : _ruleResult$fixerProp.ruleLayout
  }, customFixer);
};
//# sourceMappingURL=custom-fixer.js.map